window.addEventListener('DOMContentLoaded', () => {
  const desktopMedia = window.matchMedia('(min-width: 990px)');

  const initHoverMenu = () => {
    const header = document.querySelector('.header__inline-menu');
    if (!header || !desktopMedia.matches) return;

    const detailsItems = Array.from(header.querySelectorAll('details'));
    detailsItems.forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      // NAPRAWA: Zezwól na przekierowanie jeśli rodzic ma link a używamy hovera
      summary.addEventListener('click', (event) => {
        const linkHandle = summary.getAttribute('id');
        if (linkHandle && linkHandle.includes('torty')) {
          window.location.href = '/collections/torty';
        }
      });

      details.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      });

      details.addEventListener('focusin', () => {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });
    });

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) {
        detailsItems.forEach((details) => {
          details.removeAttribute('open');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        });
      }
    });
  };

  initHoverMenu();
  desktopMedia.addEventListener('change', () => {
    if (desktopMedia.matches) {
      initHoverMenu();
    }
  });
});
